import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { brandingUrls } from '../../config/branding';
import { useSearchContext } from '../../providers/SearchProvider';

const Logo = ({ at = 'auth', width = 58, className, textClass, ...rest }) => {
	const { clearSearchResults, showSearchCard } = useSearchContext();
	const navigate = useNavigate();

	// 返回首页按钮点击处理函数
	const handleBackToHome = useCallback(
		(e) => {
			e.preventDefault();
			e.stopPropagation();

			if (showSearchCard) {
				// 清除搜索结果并返回首页
				clearSearchResults();
			} else {
				navigate('/dashboard');
			}
		},
		[clearSearchResults, navigate, showSearchCard],
	);
	const isNavbarBrand = at === 'navbar-top' || at === 'navbar-vertical';
	const useColoredWordmark = isNavbarBrand;

	return (
		<Link
			to='/dashboard'
			onClick={handleBackToHome}
			className='text-decoration-none d-flex align-items-center navbar-top-logo'
			style={{
				height: isNavbarBrand ? '100%' : 'auto',
			}}
			{...rest}
		>
			<div
				className={classNames('d-flex align-items-center', className)}
				style={{
					height: isNavbarBrand ? '100%' : 'auto',
				}}
			>
				{/* 顶栏：CSS max-width/max-height 约束，避免 width 属性撑出透明空隙 */}
				<img
					src={useColoredWordmark ? brandingUrls.wordmarkPrimary : brandingUrls.wordmarkWhite}
					alt='Logo'
					className={isNavbarBrand ? 'navbar-brand-wordmark' : undefined}
					{...(isNavbarBrand ? {} : { width })}
					style={{ display: 'block' }}
				/>
			</div>
		</Link>
	);
};

Logo.propTypes = {
	at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
	width: PropTypes.number,
	className: PropTypes.string,
	textClass: PropTypes.string,
};

export default Logo;
